module.exports = __webpack_public_path__ + "static/media/ibat.d8a71531.png";